import { render, staticRenderFns } from "./priority.vue?vue&type=template&id=310f31b5&"
import script from "./priority.vue?vue&type=script&lang=js&"
export * from "./priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports